import script from "./BalanceModalAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./BalanceModalAlert.vue?vue&type=script&setup=true&lang=js"

import "./BalanceModalAlert.vue?vue&type=style&index=0&id=5f48f95b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f48f95b"]])

export default __exports__